import {
    CAlert,
    CCard,
    CCardBody,
    CCardHeader,
    CCol,
    CRow
} from '@coreui/react';
import { memo, Suspense } from 'react';
import { Await, defer, useLoaderData } from 'react-router-dom';
import Spinner from '../../components/Spinner';
import { getDataFromStorage, transformedData } from '../../utils/helpers';
import { ENV } from '../../utils/constants';
import EventTable from '../../components/EventTable';
import NoData from '../../components/NoData';

const Events = () => {
    const { events } = useLoaderData();

    return (
        <Suspense fallback={<Spinner asOverlay />}>
            {events && events.length > 0 ? (
                <CRow>
                    <CCol xl={12} lg={12}>
                        <CCard>
                            <CCardHeader>Events</CCardHeader>
                            <CCardBody>
                                <Await
                                    resolve={events}
                                    errorElement={
                                        <CAlert color='danger'>
                                            An error occurred!
                                        </CAlert>
                                    }
                                    children={el => <EventTable events={el} />}
                                />
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            ) : (
                <NoData title='Events' />
            )}
        </Suspense>
    );
};

export const loader = async () => {
    return defer({ events: await getEvents() });
};

export const getEvents = async () => {
    const { token } = getDataFromStorage();
    const res = await fetch(`${ENV.adminBaseUrl}/events`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!res.ok) throw res;
    const resData = await res.json();
    return transformedData(resData.data);
};

export default memo(Events);
